import useReveal from '@/hooks/useReveal';

const pillars = [
  {
    title: 'Clean Architecture & Scalable Systems',
    description:
      'Building maintainable codebases with clear separation of concerns and modular design principles that ensure long-term adaptability and seamless scaling as requirements evolve over time.',
    bgClass: 'bg-primary-50',
  },
  {
    title: 'Performance Optimization & Stability',
    description:
      'Delivering high-performance systems through rigorous optimization, efficient resource management, and comprehensive stability testing to guarantee reliable operation under real-world conditions.',
    bgClass: 'bg-accent-50',
  },
  {
    title: 'User-Centered Design & Technical Quality',
    description:
      'Combining intuitive user experiences with robust technical foundations, ensuring every solution meets high standards of usability while maintaining exceptional code quality and technical integrity.',
    bgClass: 'bg-secondary-50',
  },
];

export default function EngineeringPillars() {
  const { ref, visible } = useReveal();

  return (
    <section className="relative w-full bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto py-28 md:py-32 lg:py-40 px-6 md:px-10 lg:px-20">
        <div className="text-center mb-16 md:mb-20">
          <p className="text-[11px] font-body font-medium uppercase tracking-[0.2em] text-foreground-500 mb-4">
            Engineering Approach
          </p>
          <h2 className="font-body text-[36px] sm:text-[44px] md:text-[52px] font-bold leading-[1.15] text-foreground-950 mb-4">
            How We Build
          </h2>
          <p className="text-[15px] sm:text-[16px] md:text-[17px] font-body font-normal leading-[1.6] text-foreground-600 max-w-[480px] mx-auto">
            A disciplined approach to software engineering grounded in three foundational pillars
          </p>
        </div>

        <div
          ref={ref}
          className={`reveal ${visible ? 'visible' : ''} grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 lg:gap-9`}
        >
          {pillars.map((pillar) => (
            <div
              key={pillar.title}
              className={`${pillar.bgClass} rounded-[28px] p-8 md:p-9 lg:p-10 flex flex-col`}
            >
              <h3 className="font-body text-[20px] sm:text-[21px] md:text-[22px] font-bold leading-[1.25] text-foreground-950 mb-6">
                {pillar.title}
              </h3>
              <p className="text-[14px] sm:text-[15px] font-body font-normal leading-[1.65] text-foreground-700">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}